import type { EmployeeList } from '@/types/Psychosocial';
import type { GetEmployeesListResponseDTO } from '@/core/dto/psychosocial-report';

export class GetEmployeesListMapper {
	constructor(private readonly data: GetEmployeesListResponseDTO) {}

	toDomain(): EmployeeList {
		return {
			count: this.data?.count ?? 0,
			rows:
				this.data?.rows.map((row) => ({
					id: row.id,
					name: row.name,
					email: row.email,
					sectors: row.sectors,
					cellules: row.cellules,
					workstations: row.workstations,
					employee_code: row.employee_code,
					role: row.role,
					gender: row.gender,
					birth_date: row.birth_date,
					admission_date: row.admission_date,
					work_shift: row.work_shift,
					education: row.education
				})) ?? []
		};
	}
}
